<template>
  <v-row >
    <v-col cols-12 md-6 >

      <div class="my-2">
        <div v-for="col in meta.columns" :key="col">
          <base-geo-cell v-if = "col.fieldname === 'name'" @update:model-value="getGenusName" v-bind="{mode:'edit', column:col, initValue:curentRow[col.fieldname], meta:meta, rowobject:curentRow}" v-model="curentRow[col.fieldname]"/>
        </div>
        <!-- @update:model-value="getGenusName" - при любом изменении в поле происходит метод но только после обновления ModelValue-->
      </div>
      <div v-for="col in meta.columns" :key="col">
        <base-geo-cell v-if = "col.fieldname === 'refmainsynonym'" v-bind="{mode:'edit', column:col, initValue:curentRow[col.fieldname], meta:meta, rowobject:curentRow}" v-model="curentRow[col.fieldname]"/>
      </div>
      <v-sheet class="d-flex flex-wrap mb-2">
        <v-sheet style="min-width: 110px; max-width: 100%;" class="mr-1">
          <div v-for="col in meta.columns" :key="col">
            <base-geo-cell v-if = "col.fieldname === 'mgroup'" v-bind="{mode:'edit', column:col, initValue:curentRow[col.fieldname], meta:meta, rowobject:curentRow}" v-model="curentRow[col.fieldname]"/>
          </div> 
        </v-sheet>
        <v-sheet style="min-width: 300px; max-width: 100%;" class="mr-1">
          <div v-for="col in meta.columns" :key="col">
            <base-geo-cell v-if = "col.fieldname === 'cfsspslfvsp'" v-bind="{mode:'edit', column:col, initValue:curentRow[col.fieldname], meta:meta, rowobject:curentRow}" v-model="curentRow[col.fieldname]"/>
          </div>
        </v-sheet>
      </v-sheet>
      <v-sheet class="d-flex flex-wrap mb-2">
        <v-sheet style="min-width: 300px; max-width: 100%;" class="mr-1">
          <div v-for="col in meta.columns" :key="col">
            <base-geo-cell v-if = "col.fieldname === 'genus'" v-bind="{mode:'edit', column:col, initValue:curentRow[col.fieldname], meta:meta, rowobject:curentRow}" v-model="curentRow[col.fieldname]"/>
          </div>
        </v-sheet>
        <v-sheet style="min-width: 300px; max-width: 100%;" class="mr-1">
          <div v-for="col in meta.columns" :key="col">
            <base-geo-cell v-if = "col.fieldname === 'family'" v-bind="{mode:'edit', column:col, initValue:curentRow[col.fieldname], meta:meta, rowobject:curentRow}" v-model="curentRow[col.fieldname]"/>
          </div> 
        </v-sheet>
        <v-sheet style="min-width: 300px; max-width: 100%;" class="mr-1">
          <div v-for="col in meta.columns" :key="col">
            <base-geo-cell v-if = "col.fieldname === 'ord'" v-bind="{mode:'edit', column:col, initValue:curentRow[col.fieldname], meta:meta, rowobject:curentRow}" v-model="curentRow[col.fieldname]"/>
          </div><br>
        </v-sheet>
        <v-sheet style="min-width: 300px; max-width: 100%;" class="mr-1">
          <div v-for="col in meta.columns" :key="col">
            <base-geo-cell v-if = "col.fieldname === 'subclass'" v-bind="{mode:'edit', column:col, initValue:curentRow[col.fieldname], meta:meta, rowobject:curentRow}" v-model="curentRow[col.fieldname]"/>
          </div><br>
        </v-sheet>
        <v-sheet style="min-width: 300px; max-width: 100%;" class="mr-1">
          <div v-for="col in meta.columns" :key="col">
            <base-geo-cell v-if = "col.fieldname === 'class'" v-bind="{mode:'edit', column:col, initValue:curentRow[col.fieldname], meta:meta, rowobject:curentRow}" v-model="curentRow[col.fieldname]"/>
          </div><br>
        </v-sheet>
                
      </v-sheet>
<!--additional data-->
<v-sheet class="d-flex flex-wrap">
      <div v-for="col in meta.columns" :key="col">
        <v-sheet v-if = "col.description.includes('additionaldata')" class="mr-1" min-width="200">
          <base-geo-cell v-bind="{mode:'edit', column:col, initValue:curentRow[col.fieldname], meta:meta, rowobject:curentRow}" v-model="curentRow[col.fieldname]"/>
        </v-sheet>
      </div>
    </v-sheet>
<!--additional data end -->
<div v-for="col in meta.columns" :key="col">
  <base-geo-cell v-if = "col.fieldname === 'termdescription'" v-bind="{mode:'edit', column:col, initValue:curentRow[col.fieldname], meta:meta, rowobject:curentRow}" v-model="curentRow[col.fieldname]"/>
</div>
  <!--end of first column-->
</v-col>

  </v-row>
<!--dialogs:-->
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'StandardBaseFormT',
    components: {

},

data(){ 
    return {

    }
},
props:['meta', 'curentRow', 'modelValue'],
emits: ['update:modelValue'],

methods: {
  getGenusName(){
//  console.log('#',this.curentRow['name'],'#');
    this.curentRow['genus'] = this.curentRow['name'].split(' ')[0];
  },
},

mounted(){
//  console.log('#',this.curentRow['name'],'#');
  if (this.curentRow['name']) {
    this.getGenusName()
  }
},


})
</script>